module.exports = __webpack_public_path__ + "img/shutterstock_379530769.8d67e240.png";